import React from 'react';
import TonicDominantSpellInputs from './TonicDominantSpellInputs';
import { PRIMARY_TRIAD_GROUPS, primaryTriadKeyLabel } from '../editor/majorTriadSpellModel.js';

export default function PrimaryTriadsSpellInputs({config,value={},onChange,mode,feedback}) {
 return <div style={{display:'flex',flexDirection:'column',gap:20,width:982,flexShrink:0}}>
  <div style={{display:'grid',gridTemplateColumns:'220px repeat(3, 230px)',columnGap:24,alignItems:'center'}}>
   <span />{PRIMARY_TRIAD_GROUPS.map(group=><strong key={group.id} style={{textAlign:'center'}}>{group.label}</strong>)}
  </div>
  {(config.rows||[]).map(row=>{
   const prefix=row.id+'_';
   const rowValue=Object.fromEntries(Object.entries(value).filter(([id])=>id.startsWith(prefix)).map(([id,v])=>[id.slice(prefix.length),v]));
   const parts=Object.fromEntries(Object.entries(feedback?.parts||{}).filter(([id])=>id.startsWith(prefix)).map(([id,v])=>[id.slice(prefix.length),v]));
   return <TonicDominantSpellInputs key={row.id}
    config={{singleRow:true,hideGroupHeadings:true,groups:PRIMARY_TRIAD_GROUPS,keyLabel:primaryTriadKeyLabel(row),ariaLabelPrefix:primaryTriadKeyLabel(row)}}
    value={rowValue} mode={mode} feedback={{parts}}
    onChange={next=>onChange({...value,...Object.fromEntries(Object.entries(next).map(([id,v])=>[prefix+id,v]))})}/>;
  })}
 </div>;
}
